var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useRef, useLayoutEffect, useEffect, useState } from 'react';
import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';
import useViewport from '../../hooks/useViewport';
import { Player } from '@lottiefiles/react-lottie-player';
var isValidHttpUrl = function (str) {
    var url;
    try {
        url = new URL(str);
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
};
var isJsonString = function (str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
var inputValidation = function (input) {
    var output = input;
    if (typeof input === 'string') {
        if (isJsonString(input)) {
            output = JSON.parse(input);
        }
        else if (isValidHttpUrl(input)) {
            output = input;
        }
        else {
            output = '';
        }
    }
    else if (typeof input === 'object') {
        output = input;
    }
    else {
        output = '';
    }
    return output;
};
var data = {
    lottiePathDesktop: 'https://assets6.lottiefiles.com/private_files/lf30_nshmb1el.json',
    lottiePathMobile: 'https://assets1.lottiefiles.com/private_files/lf30_mfpnz3mw.json',
};
var defaultProps = {
    data: data,
};
export var LottieSlide = function (_a) {
    var propClassName = _a.className, _b = _a.data, slide = _b.slide, lottiePathDesktop = _b.lottiePathDesktop, lottiePathMobile = _b.lottiePathMobile, isOnScreen = _a.isOnScreen, setLottieAnimationStatus = _a.setLottieAnimationStatus, activeSlide = _a.activeSlide, autoplay = _a.autoplay, standalone = _a.standalone, _c = _a.isScrubSlide, isScrubSlide = _c === void 0 ? false : _c, onRightArrow = _a.onRightArrow, props = __rest(_a, ["className", "data", "isOnScreen", "setLottieAnimationStatus", "activeSlide", "autoplay", "standalone", "isScrubSlide", "onRightArrow"]);
    var playerRef = useRef(null);
    var wrapperRef = useRef(null);
    var _d = useViewport(), visualViewport = _d.visualViewport, breakPoints = _d.breakPoints;
    var _e = useState(null), lottieInteractivity = _e[0], setLottieInteractivity = _e[1];
    var _f = useState(null), lottieInterface = _f[0], setLottieInterface = _f[1];
    // Handy Conditionals
    var isMobile = visualViewport.width <= 850;
    // Initializing Styles variables
    var className = "flex lg:block items-center justify-center " + (isMobile ? 'h-full w-auto' : isScrubSlide ? 'w-full' : 'w-full h-auto');
    var resetLottie = function () {
        var _a, _b;
        (_a = playerRef === null || playerRef === void 0 ? void 0 : playerRef.current) === null || _a === void 0 ? void 0 : _a.setSeeker(0);
        (_b = playerRef === null || playerRef === void 0 ? void 0 : playerRef.current) === null || _b === void 0 ? void 0 : _b.pause();
    };
    var onReady = function () {
        if (isScrubSlide === true && !lottieInteractivity && lottieInterface) {
            try {
                var totalEndFrames = lottieInterface.totalFrames;
                var lottieInteractivity_1 = create({
                    mode: 'scroll',
                    player: lottieInterface,
                    speed: 1.5,
                    container: document.getElementById("scroll-lottie-slider"),
                    actions: [
                        {
                            visibility: [0.16, 1],
                            type: 'seek',
                            frames: [0, totalEndFrames],
                        },
                    ],
                });
                setLottieInteractivity(lottieInteractivity_1);
            }
            catch (error) {
                console.log('error', error);
            }
        }
    };
    useEffect(function () {
        if (lottieInterface && !lottieInteractivity && isScrubSlide) {
            onReady();
        }
    }, [lottieInterface]);
    useLayoutEffect(function () {
        var _a, _b;
        if (!isScrubSlide) {
            if (standalone) {
                if (activeSlide === slide) {
                    (_a = playerRef === null || playerRef === void 0 ? void 0 : playerRef.current) === null || _a === void 0 ? void 0 : _a.play();
                }
                else {
                    setTimeout(resetLottie, 500);
                }
            }
            else {
                if (activeSlide === slide && isOnScreen) {
                    (_b = playerRef === null || playerRef === void 0 ? void 0 : playerRef.current) === null || _b === void 0 ? void 0 : _b.play();
                }
                else {
                    setTimeout(resetLottie, 500);
                }
            }
        }
    }, [activeSlide, isOnScreen]);
    var autoAdvance = function () {
        if (onRightArrow) {
            onRightArrow();
        }
    };
    var onEventHandler = function (event) {
        var ready = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            ready[_i - 1] = arguments[_i];
        }
        if (event === 'complete') {
            if (setLottieAnimationStatus) {
                setLottieAnimationStatus(true);
            }
        }
        if (event === 'load' && isScrubSlide) {
            onReady();
        }
    };
    var finalSrc = function () {
        return inputValidation(isMobile ? lottiePathMobile : lottiePathDesktop);
    };
    return (_jsx("div", __assign({ className: className + " " + (propClassName || '') + " min-h-full relative " + (isScrubSlide ? 'lg:h-screen lg:overflow-hidden lg:absolute' : ''), ref: wrapperRef, id: "lottie-slide-player-wrapper" }, props, { children: isScrubSlide ? (_jsx(Player, { id: "player-ref-now", lottieRef: function (lottieReference) { return setLottieInterface(lottieReference); }, src: finalSrc(), mode: "normal", onEvent: onEventHandler, style: {
                width: '100vw',
                height: '100vh',
            } }, isMobile ? lottiePathMobile : lottiePathDesktop)) : (_jsx(Player, { src: inputValidation(isMobile ? lottiePathMobile : lottiePathDesktop), onEvent: onEventHandler, keepLastFrame: true, autoplay: autoplay, ref: playerRef, id: "player-ref-now", style: {
                width: isMobile ? 'auto' : '100%',
                height: isMobile ? '100%' : 'auto',
            } }, void 0)) }), void 0));
};
LottieSlide.defaultProps = defaultProps;
